import { DateTime } from 'luxon'
import { EMPTY_FILTERS } from './constants'

const pick = (object, keys) =>
  keys.reduce((result, key) => ({ ...result, [key]: object?.[key] }), {})

export const toCampaignState = campaign => ({
  id: campaign.id,
  name: campaign.name || '',
  body: campaign.body || '',
  audienceFilters: {
    ...EMPTY_FILTERS,
    ...Object.fromEntries(
      Object.entries(
        pick(campaign.audienceFilters, Object.keys(EMPTY_FILTERS)),
      ).filter(([, value]) => value !== null && value !== undefined),
    ),
  },
  media: (campaign.media || []).map(item =>
    pick(item, ['kind', 'url', 'title', 'mimeType']),
  ),
  offerings: (campaign.offerings || []).map(offering => ({
    offeringType: offering.offeringType,
    id: offering.offeringId,
    title: offering.title,
  })),
})

export const filtersToInput = filters =>
  Object.fromEntries(
    Object.entries(filters).filter(([key, value]) => {
      if (value === null || value === undefined || value === '') return false
      if (Array.isArray(value)) return value.length > 0
      return !(key === 'ageGroup' && value === 'ALL')
    }),
  )

export const toCampaignInput = campaign => ({
  name: campaign.name.trim(),
  body: campaign.body,
  audienceFilters: filtersToInput(campaign.audienceFilters),
  media: campaign.media.map(item =>
    Object.fromEntries(
      Object.entries(item).filter(
        ([, value]) => value !== null && value !== undefined,
      ),
    ),
  ),
  offerings: campaign.offerings.map(({ offeringType, id }) => ({
    offeringType,
    id,
  })),
})

export const recencyValue = filters => {
  const { bookedWithinDays, notBookedWithinDays } = filters
  if (bookedWithinDays) return `booked-${bookedWithinDays}`
  if (notBookedWithinDays) return `lapsed-${notBookedWithinDays}`
  return 'any'
}

export const applyRecency = (filters, value) => {
  const [kind, days] = value.split('-')
  return {
    ...filters,
    bookedWithinDays: kind === 'booked' ? Number(days) : null,
    notBookedWithinDays: kind === 'lapsed' ? Number(days) : null,
  }
}

export const isHandPicked = filters => filters.studentIds.length > 0

export const studentName = student =>
  [student?.firstName, student?.lastName].filter(Boolean).join(' ')

const formatDateTime = iso =>
  DateTime.fromISO(iso).toFormat("LLL d, yyyy 'at' h:mm a")

export const formatCampaignDate = campaign => {
  switch (campaign.status) {
    case 'SCHEDULED':
      return `Scheduled for ${formatDateTime(campaign.scheduledFor)}`
    case 'SENT':
      return `Sent ${formatDateTime(campaign.sentAt)}`
    case 'CANCELED':
      return 'Canceled before it was sent'
    default:
      return `Started ${DateTime.fromISO(campaign.createdAt).toFormat(
        'LLL d, yyyy',
      )}`
  }
}

export const formatShortDate = iso =>
  iso ? DateTime.fromISO(iso).toFormat('LLL d, yyyy') : '—'

export const formatRate = rate =>
  rate === null || rate === undefined ? '—' : `${Math.round(rate * 100)}%`

export const pluralize = (count, singular, plural = `${singular}s`) =>
  `${count} ${count === 1 ? singular : plural}`
